import { Modal } from 'antd';
import { messages } from 'src/constants/messages';

function ModalDeleteConfirm(apiUrl, error, apiCall, getName = '') {
  Modal.confirm({
    title: messages.MODAL_DELETE_TITLE,
    content: messages.MODAL_DELETE_CONTENT,
    onOk(e) {
      e();
      return new Promise((resolve, reject) => {
        apiCall(apiUrl, 'DELETE', null, 'DELETE', getName);
        if(!error) e();
        return error ? reject : resolve;
      }).catch(() => console.log('Có lỗi xảy ra!'));
    },
    okText: messages.MODAL_CONFIRM_OK,
    onCancel() {},
    cancelText: messages.MODAL_CONFIRM_CANCEL
  });
}

export default ModalDeleteConfirm;

